import styled from "styled-components";

const CommentForm = styled.div`
  padding: 15px;
  display: flex;
  border-bottom: 1px solid #efefef;
`;

export default CommentForm;
